// extracted by mini-css-extract-plugin
export default {"roboto":"qj3UAR8t","VideoBackgroundDesktop":"YSGTgMgS","VideoBackgroundMobile":"lrulVUyX"};